export interface ScriptParams {
  prompt: string;
}

export async function fetchPythonScript({ prompt }: ScriptParams): Promise<string> {
  try {
    const response = await fetch('/api/generate-script', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ prompt }),
    });

    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;
      try {
        const errorData = await response.json();
        errorMessage = errorData.error || errorMessage;
      } catch {
        // If we can't parse the error response, use the status message
      }
      throw new Error(errorMessage);
    }

    const data = await response.json();
    
    if (!data.success || !data.script) {
      throw new Error('Invalid response from server');
    }

    return data.script;
  } catch (error) {
    console.error('Error fetching Python script:', error);
    throw new Error(error instanceof Error ? error.message : 'Failed to generate script');
  }
}
